import React from "react";

import { Form, FormControlProps } from "react-bootstrap";

import { Controller, RegisterOptions, useFormContext } from "react-hook-form";

import styles from "./TextArea.module.scss";

type TextAreaProps = {
  label: string;
  name: string;
  rows?: number;
  rules?: RegisterOptions;
} & FormControlProps;

const TextArea = ({ name, label, rules, rows = 3, ...rest }: TextAreaProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <div className={styles["span-two-cols-in-grid"]}>
      <Form.Group>
        <Form.Label>{label}</Form.Label>
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field }) => (
            <Form.Control
              {...field}
              as="textarea"
              rows={rows}
              {...rest}
              isInvalid={errors?.[name]?.message !== undefined}
            />
          )}
        />
        {errors?.[name]?.message && (
          <Form.Control.Feedback type="invalid">{errors?.[name]?.message.toString()}</Form.Control.Feedback>
        )}
      </Form.Group>
    </div>
  );
};

export default TextArea;
